import { Component } from '@angular/core';

@Component({
  selector: 'app-proforma-report',
  template: `
    <p>
      proforma-report works!
    </p>
  `,
  styles: ``
})
export class ProformaReportComponent {

}
